import React from 'react';
import SearchForm from './../components/SearchForm';

export default function Search() {
	return (
		<div>
			<SearchForm />
		</div>
	);
}
